import { Link } from "react-router-dom";
import Darklogo from "../../image/beleaf_dark.webp";
import FINANCE from "../../image/newLanding/dropdown-finance.webp";
import BANKING from "../../image/newLanding/dropdown-bank.webp";
import INSURANCE from "../../image/newLanding/dropdown-insurance.webp";
import LEGAL from "../../image/newLanding/dropdown-legal.webp";
import EDU from "../../image/newLanding/drop-edu.webp";
import HEALTH from "../../image/newLanding/drop-health.webp";
import GAME from "../../image/newLanding/drop-game.webp";
import ENTERTAINMENT from "../../image/newLanding/drop-entertainment.webp";
import EVENTS from "../../image/newLanding/drop-events.webp";
import ONDEMAND from "../../image/newLanding/drop-ondemand.webp";
import RETAIL from "../../image/newLanding/drop-retail.webp";
import RESTAURANT from "../../image/newLanding/drop-restaurant.webp";
import TRAVEL from "../../image/newLanding/drop-travel.webp";
import LOGISTICS from "../../image/newLanding/drop-logistics.webp";
import ENERGY from "../../image/newLanding/drop-energy.webp";
import AGRI from "../../image/newLanding/drop-agri.webp";
import REALESTATE from "../../image/newLanding/drop-realestate.webp";
import CONSTRUCTION from "../../image/newLanding/drop-construction.webp";
import { useState } from "react";

import {
  Drawer,
  List,
  ListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const NewHead = ({ bg }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuClose = () => setMobileMenuOpen(false);

  const handleMobileClick = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="headerWrapper" style={bg}>
      <nav className="headerWrapper__navigation">
        <div className="headerWrapper__logo--container">
          <Link to="/">
            <img src={Darklogo} alt="Logo" className="chrisma-logo" />
          </Link>
        </div>

        <div className="headerLinks">
          <nav className="navbar navbar-expand-lg navbar-light ">
            <div className="container-fluid">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              ></button>

              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  <li className="nav-item dropdown">
                    <div
                      className="nav-link dropdown-toggle primary__landing--ListItem"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Blockchain
                    </div>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <div className="bot-nav bot-blockchain">
                        {/* first section */}
                        <div className="col-4">
                          {/* blockchain services */}
                          <div className="blockchain__nav--wrapper">
                            <h4>
                              <span className="block-span">Blockchain</span>{" "}
                              Services
                            </h4>
                            <p className="mb-4">
                              Unlock the potential of blockchain with our
                              cutting-edge solutions driving innovation and
                              efficiency.
                            </p>
                          </div>
                          {/* blockchain solution */}
                          <div>
                            <h5 className="landing__nav--title">
                              Blockchain solution
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/blockchain-based-carbon-credit-platform-development">
                                  Carbon Credit Platform Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/dapp-development-company">
                                  dApp Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/own-blockchain-development-company">
                                  Own Blockchain Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/enterprise-blockchain-development-company">
                                  Enterprise Blockchain Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/dao-development-company">
                                  DAO Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              {/* <li>
                                <Link to="/contact-us">
                                  Blockchain Social Media Platform Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li> */}
                              <li>
                                <Link to="/smart-contract-auditing-service-company">
                                  Smart Contract Audit
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/cardano-blockchain-development-company">
                                  Cardano Blockchain Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/bitcoin-mining-software-development">
                                  Bitcoin Mining Software
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/real-estate-tokenization">
                                  Real Estate Tokenization
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          {/* crypto payment solution */}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              Crypto Payment Solution
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/crypto-payment-gateway-development-services">
                                  {" "}
                                  Crypto Payment Gateway Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-wallet-app-development">
                                  Crypto Wallet Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>{" "}
                          {/* nft marketplace */}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              NFT Marketplace
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/nft-marketplace-development-service">
                                  NFT Market Place Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/nft-game-development-company">
                                  NFT Gaming Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/metaverse-nft-marketplace-development-company">
                                  Metaverse NFT MarketPlace Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          {/* License & Coin Listing */}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              License & Coin Listing
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/vara-license-consultant">
                                  {" "}
                                  VARA License Consultant{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-listing-agency">
                                  {" "}
                                  Crypto Listing Agency{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/fiu-consultant">
                                  {" "}
                                  FIU Consultant{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-licensing">
                                  {" "}
                                  Crypto Licensing{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* second section */}
                        <div className="col-4">
                          {/* crypto exchange*/}
                          <div>
                            <h5 className="landing__nav--title">
                              Crypto Exchange
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/cryptocurrency-exchange-development-company">
                                  Crypto Exchange Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/centralized-cryptocurrency-exchange-development">
                                  Centralized Exchange Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/cryptocurrency-exchange-script">
                                  Cryptocurrency Exchange Clone Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/white-label-cryptocurrency-exchange-software">
                                  White Label Crypto Exchange{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/decentralized-cryptocurrency-exchange-development">
                                  Decentralized Exchange Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/margin-trading-exchange-development">
                                  Margin Trading Exchange Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          {/*Crypto Token solution */}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              Crypto Token solution
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/token-development-company">
                                  {" "}
                                  Crypto Token Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/meme-coin-development-company">
                                  Meme Coin Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/solana-meme-coin">
                                  {" "}
                                  Solana Meme Coin Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/stablecoin-development-company">
                                  {" "}
                                  Stablecoin Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/ico-development-company">
                                  ICO Token Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/sto-development-company">
                                  STO Token Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/central-bank-digital-currency-development-company">
                                  Central Bank Digital Currency Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/real-world-asset-token-development">
                                  Real World Asset Token Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/semi-fungible-token-development">
                                  Semi Fungible Token Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-launchpad-development-company">
                                  Crypto Launchpad Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>{" "}
                          {/* defi solution */}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              Defi Solution
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/defi-staking-platform-development">
                                  {" "}
                                  Defi Staking Platform{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/defi-development-company">
                                  Defi Crypto Solution{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          {/*  P2p Development */}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              P2p Development
                            </h5>
                            <ul className="landing__nav--links border__bottom-none">
                              <li>
                                <Link to="/p2p-cryptocurrency-exchange-development-company">
                                  {" "}
                                  P2P Exchange Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/crypto-otc-trading-platform-development"
                                  className="otc-pb"
                                >
                                  OTC Platform Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* third section */}{" "}
                        <div className="col-4">
                          {/* Trading Bot */}
                          <div>
                            <h5 className="landing__nav--title">Trading Bot</h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/crypto-arbitrage-trading-bot">
                                  Arbitrage Bot Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-trading-bot-development-company">
                                  Crypto Trading Bot Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-market-making-services">
                                  Crypto Market Making Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/mev-bot-development-company">
                                  MEV Bot Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-algo-trading-bot-development">
                                  Algo Trading Software Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-flash-loan-arbitrage-bot-development">
                                  {" "}
                                  Flash Loan Arbitrage Bot Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/crypto-smart-order-routing-services">
                                  {" "}
                                  Smart Order Routing Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          {/* Clone Script */}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              Clone Script
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/binance-clone-script-development">
                                  Binance Clone Script
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/opensea-clone-script">
                                  OpenSea Clone Script
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/rarible-clone-script">
                                  Rarible Clone Script
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/coinbase-clone-script">
                                  Coinbase Clone Script Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/paxful-clone-script-development-company">
                                  Paxful Clone Script Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/wazirx-clone-script-development">
                                  WazirX Clone Script Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/local-bitcoin-clone">
                                  Localbitcoin Clone Script Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/pancakeswap-clone-script-development">
                                  Pancake Swap Clone Script
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/zerodha-clone-app">
                                  Zerodha Clone Script
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/etoro-clone">
                                  eToro Clone
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/polymarket-clone-script">
                                  Polymarket Clone
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/phonepe-clone-app">
                                  Phonepe Clone
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          {/* Game Development */}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              Game Development
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/crypto-casino-game-development">
                                  Crypto Casino Game Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/betfury-clone-script-development-company">
                                  Betfury Clone Script Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/blockchain-game-development">
                                  Blockchain Game Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <div
                      className="nav-link dropdown-toggle primary__landing--ListItem"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      AI & ML
                    </div>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <div className="bot-nav bot-ai">
                        {/* first section */}
                        <div className="col-6">
                          {/* blockchain services */}
                          <div className="blockchain__nav--wrapper">
                            <h4>
                              <span className="block-span">AI & ML</span>{" "}
                              Services
                            </h4>
                            <p className="mb-4">
                              Our AI & ML services automate processes, boost
                              efficiency, and cut costs, driving innovation.
                            </p>
                          </div>{" "}
                          {/* blockchain solution */}
                          <div className="nav__ai--wrapper">
                            <img
                              src={require("../../image/newLanding/dropdown-ai.webp")}
                              alt="ai-bot"
                              loading="lazy"
                            />
                          </div>
                        </div>
                        {/* second section */}
                        <div className="col-6">
                          {/* artificial intelligence*/}
                          <div>
                            <h5 className="landing__nav--title">
                              Artificial Intelligence
                            </h5>
                            <ul className="landing__nav--links border__bottom-none">
                              {/* <li>
                                <Link to="/contact-us">
                                  AI Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li> */}
                              <li>
                                <Link to="/ai-and-ml-development-company">
                                  AI/ML Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/generative-ai-development-company">
                                  Generative AI Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/ai-chatbot-development-company">
                                  {" "}
                                  AI Chatbot Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/ai-agent-development-company">
                                  {" "}
                                  AI Agent Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/machine-learning-consulting-services">
                                  {" "}
                                  Machine Learning Consulting{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/ai-copilot-development-company">
                                  {" "}
                                  AI Copilot Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <div
                      className="nav-link dropdown-toggle primary__landing--ListItem"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Services
                    </div>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <div className="bot-nav bot-services">
                        {/* first section */}
                        <div className="col-4">
                          <div className="blockchain__nav--wrapper">
                            <h4>
                              <span className="block-span">Our</span> Services
                            </h4>
                            <p className="mb-4">
                              We provide expert blockchain development to keep
                              your business running smoothly and efficiently.
                            </p>
                          </div>{" "}
                          <div className="nav__ai--wrapper service-img">
                            <img
                              src={require("../../image/newLanding/dropdown-blockchain.webp")}
                              alt="nav-blockchain"
                              loading="lazy"
                            />
                          </div>
                        </div>
                        {/* second section */}
                        <div className="col-4">
                          <div>
                            <h5 className="landing__nav--title">
                              Web3 Solution
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/web3-development-solution">
                                  Web3 Solutions{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/metaverse-development-company">
                                  Metaverse Development Company{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              On demand
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/uber-clone">
                                  {" "}
                                  Uber clone Script
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/dating-app-development-company">
                                  {" "}
                                  Dating App Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/food-delivery-app-development-company">
                                  {" "}
                                  Food Delivery App Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/healthcare-app-development-company">
                                  {" "}
                                  Healthcare App Development
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/amazon-clone">
                                  {" "}
                                  Amazon Clone
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/airbnb-clone">
                                  {" "}
                                  Airbnb Clone
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              Web App development
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/contact-us">
                                  {" "}
                                  Web App Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              Forex Trading
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/forex-trading-software-development">
                                  Forex Trading Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/forex-trading-bot">
                                  Forex Trading Bot Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              mobile app development
                            </h5>
                            <ul className="landing__nav--links border__bottom-none">
                              <li>
                                <Link to="/mobile-app-development-company">
                                  IOS App Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>{" "}
                                </Link>
                              </li>
                              <li>
                                <Link to="/mobile-app-development-company">
                                  Android App Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/mobile-app-development-company">
                                  Progressive App Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li className="otc-pb">
                                <Link to="/fantasy-sports-app-development-company">
                                  Fantasy Sports App Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              {/* <li className="otc-pb">
                                <Link to="/loan-lending-app-development">
                                  Loan Lending App Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li> */}
                            </ul>
                          </div>
                        </div>
                        {/* third section */}
                        <div className="col-4">
                          <div>
                            <h5 className="landing__nav--title">
                              Software development
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/custom-software-development-company">
                                  {" "}
                                  Nearshore Software Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/custom-software-development-company">
                                  Agile Software Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/custom-software-development-company">
                                  Custom Software Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/custom-software-development-company">
                                  Offshore Development Service{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/custom-software-development-company">
                                  CRM Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/custom-software-development-company">
                                  ERP Software Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/supply-chain-software-development">
                                  Supply Chain Software Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>{" "}
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              Stock Trading
                            </h5>
                            <ul className="landing__nav--links ">
                              <li>
                                <Link to="/stock-trading-app-development-company">
                                  Stock Trading Development{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="landing__nav--title mt-4">
                              digital marketing
                            </h5>
                            <ul className="landing__nav--links border__bottom-none">
                              <li>
                                <Link to="/contact-us">
                                  Branding{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/contact-us">
                                  SEO & SMM{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/contact-us">
                                  Content Marketing{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/contact-us">
                                  ICO Marketing{" "}
                                  <span className="mx-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <div
                      className="nav-link dropdown-toggle primary__landing--ListItem"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Industries
                    </div>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <div className="bot-nav bot-ind">
                        {/* first section */}
                        <div className="col-4">
                          <div className="blockchain__nav--wrapper">
                            <h4>
                              <span className="block-span">Industries</span> We
                              Serve
                            </h4>
                            <p className="mb-4">
                              We're here to meet all your blockchain development
                              needs with expert, top-quality services for smooth
                              business operations.
                            </p>
                          </div>{" "}
                        </div>
                        {/* second section */}
                        <div className="col-3">
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={FINANCE}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Finance</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={BANKING}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Banking</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={INSURANCE}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Insurance</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={LEGAL}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Legal</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={EDU}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Education</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={HEALTH}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Health</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={GAME}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Game</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={ENTERTAINMENT}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Entertainment</span>
                          </Link>
                        </div>
                        {/* third section */}
                        <div className="col-3">
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={EVENTS}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Events</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={ONDEMAND}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>On Demand</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={RETAIL}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Retail & E-Commerce</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={RESTAURANT}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Restaurant</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={TRAVEL}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Travel</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={LOGISTICS}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Logistics</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={ENERGY}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Energy Industry</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={AGRI}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Agriculture</span>
                          </Link>
                        </div>
                        {/* fourth section */}
                        <div className="col-2">
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={REALESTATE}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Real Estates</span>
                          </Link>
                          <Link
                            to="/contact-us"
                            className="landing__nav--industry"
                          >
                            <div>
                              <img
                                src={CONSTRUCTION}
                                alt="finance"
                                className="landing__nav--ind-img"
                              />
                            </div>
                            <span>Construction</span>
                          </Link>
                        </div>
                      </div>
                    </ul>
                  </li>

                  {/* <li className="nav-item dropdown">
                    <a
                      href="/contact-us"
                      className="nav-link dropdown-toggle primary__landing--ListItem"
                    >
                      About Us
                    </a>
                  </li> */}

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle primary__landing--ListItem"
                      to="/career"
                    >
                      Career
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <li>
            <Link
              to="/contact-us"
              className="primary-landing-btn primary-contact-hover"
            >
              Contact Us
            </Link>
          </li>
        </div>

        <div className="headerWrapper__navigation--hamburger">
          <p>
            <div className="landing-ham" onClick={handleMobileClick}>
              <i className="fa-solid fa-bars"></i>
            </div>
          </p>
        </div>

        {/* mobile sidebar */}
        <Drawer
          anchor="right"
          open={mobileMenuOpen}
          onClose={handleMobileMenuClose}
          className="primary__landing-drawer-menu"
        >
          <div className="mobileMenu">
            {/* Logo Section (old)*/}
            <div className="logo_new_sectio mobileMenu-logo">
              <Link to="/">
                <img src={Darklogo} className="img-fluid" alt="logo" />
              </Link>

              <div
                className="mr-4 landing-cross-icon"
                onClick={handleMobileClick}
              >
                <i className="fa-solid fa-xmark"></i>
              </div>
            </div>

            <List className="primary__landing-drawer-menu-list">
              <Accordion className="primary__landing-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="primary__accordian-title"
                >
                  <p>Blockchain</p>
                </AccordionSummary>
                <AccordionDetails className="primary__accordian-details">
                  <div className="primary__accordian-links-wrap">
                    <h5 className="my-3">Blockchain solution</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/blockchain-based-carbon-credit-platform-development">
                          Carbon Credit Platform Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/dapp-development-company">
                          dApp Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/own-blockchain-development-company">
                          Own Blockchain Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/enterprise-blockchain-development-company">
                          Enterprise Blockchain Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/dao-development-company">
                          DAO Development Company
                        </Link>
                      </ListItem>
                    </List>
                    {/* <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/contact-us">
                          Blockchain Social Media Platform Development{" "}
                        </Link>
                      </ListItem>
                    </List> */}
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/smart-contract-auditing-service-company">
                          Smart Contract Audit
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/cardano-blockchain-development-company">
                          Cardano Blockchain Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/bitcoin-mining-software-development">
                          Bitcoin Mining Software
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/real-estate-tokenization">
                          Real Estate Tokenization
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>Crypto Payment Solution</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-payment-gateway-development-services">
                          Crypto Payment Gateway Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-wallet-app-development">
                          Crypto Wallet Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>NFT Marketplace</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/nft-marketplace-development-service">
                          NFT Market Place Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/nft-game-development-company">
                          NFT Gaming Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/metaverse-nft-marketplace-development-company">
                          Metaverse NFT MarketPlace Development
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>License & Coin Listing</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/vara-license-consultant">
                          VARA License Consultant
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-listing-agency">
                          Crypto Listing Agency
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/fiu-consultant">FIU Consultant</Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-licensing">Crypto Licensing</Link>
                      </ListItem>
                    </List>
                  </div>

                  <div className="primary__accordian-links-wrap">
                    <h5>Crypto Exchange</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/cryptocurrency-exchange-development-company">
                          Crypto Exchange Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/centralized-cryptocurrency-exchange-development">
                          Centralized Exchange Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link href="/cryptocurrency-exchange-script">
                          Cryptocurrency Exchange Clone Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/white-label-cryptocurrency-exchange-software">
                          White Label Crypto Exchange{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/decentralized-cryptocurrency-exchange-development">
                          Decentralized Exchange Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/margin-trading-exchange-development">
                          Margin Trading Exchange Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>Crypto Token solution</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/token-development-company">
                          Crypto Token Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/meme-coin-development-company">
                          Meme Coin Development Company
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/solana-meme-coin">
                          Solana Meme Coin Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/stablecoin-development-company">
                          Stablecoin Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/ico-development-company">
                          ICO Token Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/sto-development-company">
                          STO Token Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/central-bank-digital-currency-development-company">
                          Central Bank Digital Currency Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/real-world-asset-token-development">
                          Real World Asset Token Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/semi-fungible-token-development">
                          Semi Fungible Token Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-launchpad-development-company">
                          Crypto Launchpad Development
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>P2p Development</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/p2p-cryptocurrency-exchange-development-company">
                          P2P Exchange Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-otc-trading-platform-development">
                          OTC Platform Development
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>Defi Solution</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/defi-staking-platform-development">
                          Defi Staking Platform
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/defi-development-company">
                          Defi Crypto Solution
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>Trading Bot</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-arbitrage-trading-bot">
                          Arbitrage Bot Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-trading-bot-development-company">
                          Crypto Trading Bot Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-market-making-services">
                          Crypto Market Making Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/mev-bot-development-company">
                          MEV Bot Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-algo-trading-bot-development">
                          Algo Trading Software Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-flash-loan-arbitrage-bot-development">
                          Flash Loan Arbitrage Bot Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-smart-order-routing-services">
                          Smart Order Routing Development
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>Clone Script</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-arbitrage-trading-bot">
                          Binance Clone Script
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/opensea-clone-script">
                          OpenSea Clone Script
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/rarible-clone-script">
                          Rarible Clone Script
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/coinbase-clone-script">
                          Coinbase Clone Script Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/paxful-clone-script-development-company">
                          Paxful Clone Script Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/wazirx-clone-script-development">
                          WazirX Clone Script Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/local-bitcoin-clone">
                          Localbitcoin Clone Script Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/pancakeswap-clone-script-development">
                          Pancake Swap Clone Script
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/zerodha-clone-app">
                          Zerodha Clone Script
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/etoro-clone">eToro Clone</Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/polymarket-clone-script">
                          Polymarket Clone
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/phonepe-clone-app">Phonepe Clone</Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5>Game Development</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/crypto-casino-game-development">
                          Crypto Casino Game Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/betfury-clone-script-development-company">
                          Betfury Clone Script Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/blockchain-game-development">
                          Blockchain Game Development
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                </AccordionDetails>
              </Accordion>

              <Accordion className="primary__landing-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="primary__accordian-title"
                >
                  <p>AI & ML</p>
                </AccordionSummary>
                <AccordionDetails className="primary__accordian-details">
                  <div className="primary__accordian-links-wrap">
                    <h5 className="my-3">Artificial intelligence</h5>
                    {/* <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/contact-us">AI Development Company </Link>
                      </ListItem>
                    </List> */}
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/ai-and-ml-development-company">
                          AI/ML Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/generative-ai-development-company">
                          Generative AI Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/ai-chatbot-development-company">
                          AI Chatbot Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/ai-agent-development-company">
                          AI Agent Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/machine-learning-consulting-services">
                          Machine Learning Consulting{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/ai-copilot-development-company">
                        AI Copilot Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                </AccordionDetails>
              </Accordion>

              <Accordion className="primary__landing-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="primary__accordian-title"
                >
                  <p>Services</p>
                </AccordionSummary>
                <AccordionDetails className="primary__accordian-details">
                  <div className="primary__accordian-links-wrap">
                    <h5 className="my-3">Web3 Solution</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/web3-development-solution">
                          Web3 Solutions{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/metaverse-development-company">
                          Metaverse Development Company{" "}
                        </Link>
                      </ListItem>
                    </List>
                  </div>

                  <div className="primary__accordian-links-wrap">
                    {" "}
                    <h5 className="my-3">On demand</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/uber-clone">Uber clone Script</Link>
                      </ListItem>
                      <ListItem button className="primary__accordian-links">
                        <Link to="/dating-app-development-company">
                          Dating App Development
                        </Link>
                      </ListItem>
                      <ListItem button className="primary__accordian-links">
                        <Link to="/food-delivery-app-development-company">
                          Food Delivery App Development
                        </Link>
                      </ListItem>
                      <ListItem button className="primary__accordian-links">
                        <Link to="/healthcare-app-development-company">
                          Healthcare App Development
                        </Link>
                      </ListItem>
                      <ListItem button className="primary__accordian-links">
                        <Link to="/amazon-clone">Amazon Clone</Link>
                      </ListItem>
                      <ListItem button className="primary__accordian-links">
                        <Link to="/airbnb-clone">Airbnb Clone</Link>
                      </ListItem>
                    </List>
                  </div>

                  <div className="primary__accordian-links-wrap">
                    {" "}
                    <h5 className="my-3">Web App development</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/contact-us">Web App Development </Link>
                      </ListItem>
                    </List>
                  </div>

                  <div className="primary__accordian-links-wrap">
                    {" "}
                    <h5 className="my-3">Forex Trading</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/forex-trading-software-development">
                          Forex Trading Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/forex-trading-bot">
                          Forex Trading Bot Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                  </div>

                  <div className="primary__accordian-links-wrap">
                    <h5 className="my-3">mobile app development</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/mobile-app-development-company">
                          IOS App Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/mobile-app-development-company">
                          Android App Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/mobile-app-development-company">
                          Progressive App Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/fantasy-sports-app-development-company">
                          Fantasy Sports App Development
                        </Link>
                      </ListItem>
                    </List>
                    {/* <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/loan-lending-app-development">
                          Loan Lending App Development
                        </Link>
                      </ListItem>
                    </List> */}
                  </div>

                  <div className="primary__accordian-links-wrap">
                    <h5 className="my-3">Software development</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/custom-software-development-company">
                          Nearshore Software Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/custom-software-development-company">
                          Agile Software Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/custom-software-development-company">
                          Custom Software Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/custom-software-development-company">
                          Offshore Development Service
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/custom-software-development-company">
                          CRM Development{" "}
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/custom-software-development-company">
                          ERP Software Development
                        </Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/supply-chain-software-development">
                          Supply Chain Software Development
                        </Link>
                      </ListItem>
                    </List>
                  </div>

                  <div className="primary__accordian-links-wrap">
                    <h5 className="my-3">Stock Trading</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/stock-trading-app-development-company">
                          Stock Trading Development
                        </Link>
                      </ListItem>
                    </List>
                  </div>
                  <div className="primary__accordian-links-wrap">
                    <h5 className="my-3">Digital marketing</h5>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/contact-us">Branding</Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/contact-us">SEO & SMM</Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/contact-us">Content Marketing</Link>
                      </ListItem>
                    </List>
                    <List className="primary__accordian-detail-lists">
                      <ListItem button className="primary__accordian-links">
                        <Link to="/contact-us">ICO Marketing</Link>
                      </ListItem>
                    </List>
                  </div>
                </AccordionDetails>
              </Accordion>

              <Accordion className="primary__landing-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="primary__accordian-title"
                >
                  <p>Industries</p>
                </AccordionSummary>
                <AccordionDetails className="primary__accordian-details">
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links mt-3">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={FINANCE}
                            alt="finance"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Finance</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={BANKING}
                            alt="banking"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Banking</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={INSURANCE}
                            alt="Insurance"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Insurance</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={LEGAL}
                            alt="Legal"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Legal</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={EDU}
                            alt="Education"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Education</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={HEALTH}
                            alt="Health"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Health</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={GAME}
                            alt="Game"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Game</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={ENTERTAINMENT}
                            alt="Entertainment"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Entertainment</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={EVENTS}
                            alt="Events"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Events</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={ONDEMAND}
                            alt="On-Demand"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>On-Demand</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={RETAIL}
                            alt="Retail & E-Commerce"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Retail & E-Commerce</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={RESTAURANT}
                            alt="Restaurant"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Restaurant</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={TRAVEL}
                            alt="Travel"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Travel</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={LOGISTICS}
                            alt="Logistics"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Logistics</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={ENERGY}
                            alt="Energy Industry"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Energy Industry</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={AGRI}
                            alt="Agriculture"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Agriculture</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={REALESTATE}
                            alt="Real Estates"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Real Estates</span>
                      </Link>
                    </ListItem>
                  </List>
                  <List className="primary__accordian-detail-lists">
                    <ListItem button className="primary__accordian-links">
                      <Link
                        to="/contact-us"
                        className="primary__accordian-industry-links"
                      >
                        <div>
                          <img
                            src={CONSTRUCTION}
                            alt="Construction"
                            className="landing__nav--ind-img"
                          />
                        </div>
                        <span>Construction</span>
                      </Link>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>

              {/* <div className="primary__drawer-links">
                <div className="primary__accordian-title">
                  <Link to="/">About us</Link>
                </div>
              </div> */}

              <div className="primary__drawer-links">
                <div className="primary__accordian-title">
                  <Link to="/career">Career</Link>
                </div>
              </div>
            </List>

            <div className=" primary__drawer-btn mt-4">
              <li>
                <Link to="/contact-us" className="primary-landing-btn">
                  Contact Us
                </Link>
              </li>
            </div>
          </div>
        </Drawer>
      </nav>
    </header>
  );
};

export default NewHead;
